import { render } from "./baseCard.vue?vue&type=template&id=4c84c68e&scoped=true"
const script = {}

import "./baseCard.vue?vue&type=style&index=0&id=4c84c68e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c84c68e"]])

export default __exports__